<div class="beitragszahler-container">
  <div class="beitragszahler-control">
    <div [class]="'beitragszahler' + (enabled ? ' clickable' : '')" (click)="onEditPerson()">
      <span class="person">{{ person | formatPerson : objektTyp }}</span>
      <mat-icon *ngIf="enabled">edit</mat-icon>
    </div>
  </div>
  <button mat-mini-fab (click)="onSelectPerson()" color="accent" class="search-button" [disabled]="!editable">
    <mat-icon class="mat-36">search</mat-icon>
  </button>
</div>
